import { GoogleLogin } from '@react-oauth/google';
import { useUIStore } from '#store';

export default function GLogin() {
  const oAuthLogin = useUIStore((state) => state.oAuthLogin);
  const onSuccess = async (res) => {
    // Login starts here
    const { credential } = res;
    await oAuthLogin(credential);
  };
  const onError = (err) => {
    console.err('failed:', err);
  };
  return <GoogleLogin onSuccess={onSuccess} onError={onError} />;
}
